var render = function render(){var _vm=this,_c=_vm._self._c;return _c('searchable-select',{attrs:{"id":_vm.id,"option_value":"value","option_label":"label","options":_vm.countryOptions,"placeholder":_vm.$t('views.registrations._form.registration_step.select', this.locale)},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})
}
var staticRenderFns = []

export { render, staticRenderFns }